export const SET_LOCATIONS = 'Set locations'
export const SET_LOCATIONS_COUNT = 'Set locations count'
export const DELETE_LOCATION = 'Delete locations'
export const UPDATE_LOCATION = 'Update locations'
